export const settingsPrimaryButtonClassName =
  "inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-cpaGold bg-cpaGold px-4 text-sm font-semibold text-white transition hover:bg-amber-500 disabled:cursor-not-allowed disabled:opacity-50";

export const settingsSecondaryButtonClassName =
  "inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 text-sm font-semibold text-gray-700 transition hover:border-gray-400 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50";

export const settingsResetButtonClassName =
  "inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-gray-500 bg-white px-4 text-sm font-semibold text-gray-600 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50";

export const settingsDangerButtonClassName =
  "inline-flex h-9 items-center justify-center gap-1 rounded-md border border-red-500 bg-red-500 px-3 text-sm font-semibold text-white transition hover:bg-red-600 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-300";

// The input class literal moved verbatim to common/dashboard/formStyles.ts
// (dashboardInputClassName) so the promoted CalendarDateInput's default has no
// pages/** dependency; re-exported here under the original name.
export { dashboardInputClassName as settingsInputClassName } from "../../../../common/dashboard/formStyles";

export const settingsReadOnlyInputClassName =
  "h-11 rounded-lg border border-[#DCE4F0] bg-white px-3 text-sm text-gray-800 shadow-sm outline-none transition read-only:bg-gray-100 read-only:text-gray-500 focus:border-cpaGold focus:ring-2 focus:ring-amber-100 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-500";

export const settingsTextareaClassName =
  "min-h-[124px] w-full resize-y rounded-lg border border-[#DCE4F0] bg-white px-3 py-3 text-sm text-gray-900 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-cpaGold focus:ring-2 focus:ring-amber-100";

export const settingsInnerPanelClassName =
  "rounded-lg bg-white p-5";

export const settingsTableHeaderClassName =
  "bg-gray-50 px-5 py-3 text-sm font-bold text-gray-950";

export const settingsSectionCardClassName =
  "rounded-lg border border-black bg-white px-6 py-6 shadow-none";

export const settingsSectionTitleClassName =
  "text-lg font-bold leading-tight text-black";

export const settingsSectionDescriptionClassName =
  "mt-1 max-w-6xl text-sm leading-6 text-black";
